var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0902 6.06986C21.4133 4.8771 18.4226 4.58161 15.564 5.22747C12.7055 5.87332 10.1323 7.42591 8.22819 9.65368C6.32411 11.8814 5.19117 14.665 4.99835 17.5893C4.80552 20.5136 5.56314 23.4218 7.15821 25.8803C8.75328 28.3388 11.1003 30.2158 13.8493 31.2315C16.5983 32.2471 19.602 32.3469 22.4123 31.5159C25.2227 30.685 27.6891 28.9679 29.4439 26.6206C31.1986 24.2734 32.1475 21.4219 32.1492 18.4913V17.1029C32.1492 16.2689 32.8253 15.5929 33.6592 15.5929C34.4932 15.5929 35.1692 16.2689 35.1692 17.1029V18.4921C35.1672 22.074 34.0074 25.5601 31.8627 28.4289C29.7181 31.2977 26.7035 33.3964 23.2686 34.412C19.8338 35.4276 16.1626 35.3056 12.8027 34.0643C9.44284 32.823 6.57422 30.5289 4.62469 27.5241C2.67516 24.5192 1.74918 20.9647 1.98486 17.3906C2.22053 13.8165 3.60523 10.4143 5.93244 7.6915C8.25965 4.96867 11.4047 3.07106 14.8985 2.28169C18.3923 1.49231 22.0476 1.85346 25.3194 3.31127C26.0812 3.6507 26.4235 4.54338 26.0841 5.30514C25.7447 6.06691 24.852 6.40928 24.0902 6.06986Z",
    fill: "#1D1D38"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.7264 5.34371C35.3164 5.93311 35.3169 6.8892 34.7275 7.47919L19.6273 22.5945C19.3442 22.8779 18.96 23.0372 18.5594 23.0373C18.1588 23.0374 17.7746 22.8783 17.4913 22.595L12.9613 18.0649C12.3716 17.4752 12.3716 16.5192 12.9613 15.9295C13.551 15.3398 14.507 15.3398 15.0967 15.9295L18.5585 19.3912L32.591 5.34478C33.1804 4.75478 34.1364 4.75431 34.7264 5.34371Z",
    fill: "#1D1D38"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.b80ae2ab.svg";
export { ForwardRef as ReactComponent };